import { render, staticRenderFns } from "./reportDetails.vue?vue&type=template&id=5f1de032&scoped=true&"
import script from "./reportDetails.vue?vue&type=script&lang=js&"
export * from "./reportDetails.vue?vue&type=script&lang=js&"
import style0 from "./reportDetails.vue?vue&type=style&index=0&id=5f1de032&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1de032",
  null
  
)

export default component.exports